import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ROUTES } from "base/routes/routes";

import { observer } from "mobx-react";
import * as rootStore from "stores/root_store";

import { createLoginLayout, createDefaultLayout } from "base/ui/layout/layout";
import { createPages } from "pages/create";

import Header from "base/ui/layout/header/header";
import Sidebar from "base/ui/layout/sideBar/sideBar";
import { Footer as FooterView } from "base/ui/layout/footer/footer";

import NotFound from "pages/error/404/404page";
import InternalServer from "pages/error/500/500page";
import Logout from "pages/logout";

import "base/ui/components/Editor/content.css";
import "react-quill/dist/quill.snow.css";
import "antd/dist/reset.css";

import { ConfigProvider } from "antd";
import viVN from "antd/locale/vi_VN";
import enUS from "antd/locale/en_US";
import { useEffect, useLayoutEffect, useState } from "react";
import i18n from "translation/i18n";
import {
  StyleProvider,
  legacyLogicalPropertiesTransformer,
} from "@ant-design/cssinjs";

export function createApp() {
  return observer(() => {
    const services = rootStore.services;

    // khởi tạo header, sidebar, footer
    // const Header = observer(() => <HeaderView />);
    // const Sidebar = observer(() => <SidebarView />);
    const Footer = observer(() => <FooterView />);

    // Tạo ra 2 layout
    // Layout cho trang login chỉ có content không có sidebar, header, footer
    const layoutLogin = createLoginLayout();
    // Layout mặc định sẽ có đầy đủ sidebar, header, footer
    const layoutDefault = createDefaultLayout(Header, Sidebar, Footer);
    // khỏi tạo các trang với layout tương ứng
    const { LoginPage, FeedbackPage } = createPages(layoutLogin, services);

    const {
      //=============Mobile=====================
      HomePage,
      ModulePage,
      CustomerInfoPage,
      IconsPage,

      // khảo sát
      AddSurveyPage,
      FormSurveyPage,
      EditSurveyPage,
      SurveyReportPage,

      // ZNS
      ZNSPage,

      // REMINDER
      RemindPage,

      // CUSTOMER
      CustomerPage,

      // QUẢN LÝ DỰ ÁN
      ProjectManagementPage,
      // CHIẾN DỊCH EVENT
      EventCampaignPage,
      // CHIẾN DỊCH MAKETING
      MarketingCampaignPage,
      // BÁO CÁO BẢO HÀNH - KHIẾU NẠI
      WarrantyAndComplaintPage,
      // CHIẾN DỊCH / CAMPAIGN
      CampaignPage,
      // Tiện ích
      PageUtilities,

      // dữ liệu nền
      MasterdataPage,

      // Tích điểm đổi quà
      ExchangeRewardsPage,

      // Báo cáo ghé thăm khách hàng SR
      ReportVisitCustomerPage
    } = createPages(layoutDefault, services);

    // Thay đổi ngôn ngữ
    useEffect(() => {
      const language = localStorage.getItem("language")
        ? JSON.parse(localStorage.getItem("language") || "")
        : "vi";
      i18n.changeLanguage(language);
    }, []);

    return (
      <>
        {/* {isLoading ? (
          // Phần loading khi reload trang
          // Chưa làm nên để trống (có thể để icon, gif, ...)
          <div></div>
        ) : ( */}
        <ConfigProvider
          // Chuyển ngôn ngữ của antd
          locale={rootStore.uiStore.language === "en" ? enUS : viVN}
          // đặt lại theme mặc định của antd (Đổi font, đổi cỡ chữ, đổi màu, ...)
          theme={{
            token: {
              colorPrimary: rootStore.uiStore.theme.color || "#1677ff",
              borderRadius: 2,
              fontSize: 13,
              fontFamily: "Roboto",
            },
          }}
        >
          <StyleProvider
            hashPriority="high"
            transformers={[legacyLogicalPropertiesTransformer]}
          >
            <BrowserRouter>
              <ScrollToTop />
              <Routes>
                {/* Trang đăng nhập */}
                <Route path={ROUTES.LOGIN.BASE} element={<LoginPage />} />
                {/* Trang chủ */}
                <Route path={ROUTES.HOME} element={<HomePage />} />
                {/* ======= MODULE PAGE ============================================================================================== */}
                <Route path={ROUTES.MODULE.BASE} element={<ModulePage />} />
                {/* ======= CUSTOMER INFO PAGE ======================================================================================= */}
                <Route
                  path={ROUTES.CUSTOMER_INFO.BASE}
                  element={<CustomerInfoPage />}
                />
                {/* ======== ICONS PAGE ============================================================================================== */}
                <Route path={ROUTES.ICONS.BASE} element={<IconsPage />} />
                {/* ======== SURVEY PAGE (KHẢO SÁT) ============================================================================================== */}
                {/* trang tạo khảo sát */}
                <Route
                  path={ROUTES.SURVEY_TABLE.BASE}
                  element={<FormSurveyPage />}
                />
                {/* tạo khảo sát */}
                <Route
                  path={ROUTES.SURVEY_TABLE.ADD}
                  element={<AddSurveyPage />}
                />
                {/* Sửa khảo sát  */}
                <Route
                  path={ROUTES.SURVEY_TABLE.EDIT.BASE}
                  element={<EditSurveyPage />}
                />
                {/* Báo cáo kết quả khảo sát */}
                <Route
                  path={ROUTES.SURVEY_TABLE.SURVEY_REPORT.BASE}
                  element={<SurveyReportPage />}
                />
                {/* Trang làm khảo sát */}
                <Route
                  path={ROUTES.SURVEY_TABLE.FEEDBACK.BASE}
                  element={<FeedbackPage />}
                />
                {/* ======== ZALO OA ============================================================================================== */}
                {/* ZNS */}
                <Route path={ROUTES.ZALO_ZNS.BASE} element={<ZNSPage />} />

                {/* Reminder */}
                <Route path={ROUTES.REMINDERS.BASE} element={<RemindPage />} />
                {/* Customer */}
                <Route path={ROUTES.CUSTOMER.BASE} element={<CustomerPage />} />
                {/* ======= PROJECT_MANAGEMENT / QUẢN LÝ DỰ ÁN============================================================================================== */}
                <Route
                  path={ROUTES.PROJECT_MANAGEMENT.BASE}
                  element={<ProjectManagementPage />}
                />
                {/* ======= EVENT CAPPAIGN / CHIẾN DỊCH EVENT ============================================================================================== */}
                <Route
                  path={ROUTES.EVENT_CAMPAIGN.BASE}
                  element={<EventCampaignPage />}
                />
                {/* ======= BÁO CÁO BẢO HÀNH - KHIẾU NẠI ============================================================================================== */}
                <Route
                  path={ROUTES.WARRANTY_COMPLAINT.BASE}
                  element={<WarrantyAndComplaintPage />}
                />
                {/* ======= MARKETING CAMPAIGN / CHIẾN DỊCH MARKETING ============================================================================================== */}
                <Route
                  path={ROUTES.MARKETING_CAMPAIGN.BASE}
                  element={<MarketingCampaignPage />}
                />
                {/* ======= CAMPAIGN / CHIẾN DỊCH ============================================================================================== */}
                <Route path={ROUTES.CAMPAIGN.BASE} element={<CampaignPage />} />

                {/* =============== BÁO CÁO THĂM HỎI GHÉ THĂM KHÁCH HÀNG =================================== */}
                <Route path={ROUTES.REPORT_VISIT_CUSTOMER.BASE} element={<ReportVisitCustomerPage />} />

                {/* =============================== TIỆN ÍCH ===================================== */}
                <Route path={ROUTES.UTILITIES.BASE} element={<PageUtilities />} />

                {/* =============================== DỮ LIỆU NỀN ===================================== */}
                <Route path={ROUTES.MASTER_DATA.BASE} element={<MasterdataPage />} />


                <Route path={ROUTES.EXCHANGE_REWARDS.BASE} element={<ExchangeRewardsPage />} />


                <Route path={"/logout"} element={<Logout />} />
                <Route path="/500" element={<InternalServer />} />
                <Route path="/*" element={<NotFound />} />


              </Routes>
            </BrowserRouter>
          </StyleProvider>
        </ConfigProvider>
        {/* )} */}
      </>
    );
  });
}

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // window.scrollTo({ top: 0, behavior: 'smooth' });
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
